import {
  SET_STOCK_TRANSFERS,
  SET_STOCK_TRANSFERS_ERROR,
  SET_STOCK_TRANSFERS_LOADING,
  SET_STOCK_TRANSFER_ACTION_LOADING,
} from "../../actions/stockTransferAction";

const initialState = {
  datas: null,
  loading: false,
  actionLoading: false,
  error: null,
};

const stockTransferReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_STOCK_TRANSFERS:
      return { ...state, datas: action.data, error: null };
    case SET_STOCK_TRANSFERS_LOADING:
      return { ...state, loading: action.status };
    case SET_STOCK_TRANSFER_ACTION_LOADING:
      return { ...state, actionLoading: action.status };
    case SET_STOCK_TRANSFERS_ERROR:
      return { ...state, loading: false, actionLoading: false, error: action.error };
    default:
      return state;
  }
};

export default stockTransferReducer;
